import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Star = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 13C28 12.45 27.55 12 27 12H19.687L16.925 4.65C16.775 4.262 16.4 4 15.987 4C15.574 4 15.2 4.263 15.049 4.65L12.311 12H4.998C4.448 12 3.998 12.45 3.998 13C3.998 13.313 4.136 13.588 4.36 13.762L9.885 18.375L8.022 26.775C8.01 26.85 7.997 26.912 7.997 26.987C7.997 27.537 8.447 27.987 8.997 27.987C9.247 27.987 9.472 27.9 9.647 27.749L15.997 22.311L22.347 27.749C22.522 27.899 22.747 27.987 22.997 27.987C23.547 27.987 23.997 27.537 23.997 26.987C23.997 26.912 23.985 26.837 23.972 26.775L22.109 18.375L27.647 13.762C27.859 13.587 27.997 13.312 27.997 13H28ZM20.363 17.238C20.075 17.476 19.95 17.863 20.026 18.226L21.376 24.301L16.651 20.251C16.463 20.088 16.226 20.013 16.001 20.013C15.776 20.013 15.538 20.088 15.351 20.251L10.626 24.289L11.976 18.214C12.051 17.851 11.926 17.464 11.638 17.226L7.763 13.988H13.001C13.413 13.988 13.788 13.726 13.939 13.338L16.002 7.838L18.065 13.338C18.215 13.725 18.59 13.988 19.003 13.988H24.241L20.366 17.238H20.363Z" />
	</svg>
);

export default Star;
